import { render } from "./TheFeatures.vue?vue&type=template&id=b3149f7a"
import script from "./TheFeatures.vue?vue&type=script&lang=js"
export * from "./TheFeatures.vue?vue&type=script&lang=js"
script.render = render

export default script